
import React from 'react'

import { useLocation, Link } from 'react-router-dom';
import EventForm from "../../../components/Form/Master/EventForm";


export default function EditMenuitem() {

    const location = useLocation();
    const detail = location.state;

  return (
    <div className="p-4">
        <div className="flex justify-between items-center py-4 px-6">
            <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Edit Event Master</h1>
            <div>
                <Link to="/maharaj_master/list" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Maharaj Selection</button>
                </Link>
                <Link to="/bowl_master/add" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Bowl Type</button>
                </Link>
                <Link to="/event_master/list">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                </Link>
            </div>
        </div>
        {/* No overflow-x-auto here. It clips on both axes, not just the one named, so a
            react-select menu opened inside could not escape: the box grew its own vertical
            scrollbar instead of letting the list drop over the page. This wrapper holds a
            form, not a wide table, so it has nothing to scroll horizontally. */}
        <div className="relative shadow-md sm:rounded-lg px-4 py-2">
           <EventForm detail={detail} />
        </div>
    </div>
  )
}
